import styled from 'styled-components';

export const NotificationIndicator = styled.div`
  border-radius: 50%;
  background-color: ${({ theme }) => theme.colors.errorRed01};
  height: 10px;
  position: absolute;
  width: 10px;
  top: ${({ top }) => top};
  right: ${({ right }) => right};
  bottom: ${({ bottom }) => bottom};
  left: ${({ left }) => left};
`;
